import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { customFetcher } from './customFetcher';
import { IStatistics, statisticsSchema } from '../Interfaces/IStatistics';
import { useAlert } from '../core/AlertContext';

export const statisticsQueryKey = ['statistics'] as const;

export const useStatisticsQuery = () => {
    const { showAlert } = useAlert();

    const query = useQuery<IStatistics, Error>({
        queryKey: statisticsQueryKey,
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: 'always',
        refetchOnReconnect: true,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const fetchedData = await customFetcher<IStatistics>({ endpoint: '/statistics' });
            return statisticsSchema.parse(fetchedData);
        },
    });

    useEffect(() => {
        if (!query.error) {
            return;
        }
        showAlert({
            severity: 'error',
            text: 'Statistiken konnten nicht geladen werden.',
        });
    }, [query.error, showAlert]);

    return query;
};
